import { render, staticRenderFns } from "./VolunteerLeftSection.vue?vue&type=template&id=5c719fd9&scoped=true"
import script from "./VolunteerLeftSection.vue?vue&type=script&lang=js"
export * from "./VolunteerLeftSection.vue?vue&type=script&lang=js"
import style0 from "./VolunteerLeftSection.vue?vue&type=style&index=0&id=5c719fd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c719fd9",
  null
  
)

export default component.exports